import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { CloseCircleOutline, ExclamationCircleOutline } from '@aslanpay/portal-common-lib';

import useDeletePayCalendars from 'app/hooks/useDeletePayCalendars';

import { DeletePayCalendarModalProps } from './types';

function DeletePayCalendarModal({
  selectedPayCalendars,
  isOpen,
  onClose,
  onDelete,
}: DeletePayCalendarModalProps) {
  const title =
    selectedPayCalendars.length > 1
      ? `Delete the selected pay calendar(s)?`
      : `Delete pay calendar?`;

  const { mutate: deletePayCalendars, isLoading: isDeletingPayCalendar } = useDeletePayCalendars({
    onSuccess: () => {
      onDelete();
      onClose();
    },
    onError: () => {
      onClose();
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <ExclamationCircleOutline color="system.error" boxSize="24px" />
            <Text as="h6">{title}</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close delete pay calendar"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            {`This will delete the selected pay calendar${
              selectedPayCalendars.length > 1 ? '(s)' : ''
            } and you will not be able to recover it after confirm.`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Spacer />
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            isLoading={isDeletingPayCalendar}
            onClick={() =>
              deletePayCalendars(
                selectedPayCalendars.map((id) => ({
                  id,
                }))
              )
            }
          >
            Yes, delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeletePayCalendarModal;
